<template>
    <rkm-overlay>
        <rkm-layout-body title="Atendimento de triagem">
            <template
                v-if="loaded"
                v-slot:center
            >
                <rkm-button
                    v-if="model.alergias.length > 0"
                    @click="handleAlergiasScroll"
                    color="alergia"
                >
                    Paciente alérgico
                </rkm-button>
            </template>

            <template
                v-if="loaded"
                v-slot:actions
            >
                <rkm-button
                    @click.stop="exit()"
                    color="danger"
                >
                    Sair
                </rkm-button>

                <rkm-button
                    @click="$refs.ModalEvasao.open($route.params.id)"
                    color="danger"
                >
                    Evasão
                </rkm-button>

                <rkm-button
                    v-if="additionals.allowDesfecho"
                    @click="handleDesfecho()"
                    color="outline-success"
                >
                    Desfecho
                </rkm-button>

                <rkm-button
                    @click="$refs.Form.save()"
                    color="primary"
                >
                    Salvar
                </rkm-button>
            </template>

            <template
                v-if="form.paciente"
                v-slot:subtitle
            >

                <div class="sub-title">
                    <rkm-icon class="icon" icon="user"/>
                    <span class="text-uppercase" v-if="form.paciente.preferenciaNomeId === enums.preferenciaNome.NOME_SOCIAL">
                        {{ form.paciente.nome }} <strong>({{ form.paciente.nomeSocial }})</strong>,
                    </span>
                    <span class="text-uppercase" v-else>
                        {{ form.paciente.nome }},
                    </span>
                    <span v-if="form.paciente.idade">
                        {{ form.paciente.idade.anos }} anos,
                        {{ form.paciente.idade.meses }} meses
                        e {{ form.paciente.idade.dias }} dias,
                    </span>
                    <span>{{ form.paciente.sexo.descricao }}</span>
                </div>
            </template>

            <rkm-layout-content v-if="loaded">
                <Form
                    :plantao-id="$route.params.plantaoId"
                    :data="{ additionals, form, model }"
                    ref="Form"
                    @save="redirectToList()"
                />
            </rkm-layout-content>
        </rkm-layout-body>

        <ModalFinalizarAtendimento
            :data="{ additionals, form, model }"
            :plantao-id="$route.params.plantaoId"
            @save="redirectToList()"
            ref="ModalFinalizarAtendimento"
        />

        <ModalEvasao
            @save="redirectToList"
            ref="ModalEvasao"
        />
    </rkm-overlay>
</template>

<script>
// Components.
import Form from '@/components/pronto-atendimento/atendimento-triagem/Form'
import ModalEvasao from '@/components/pronto-atendimento/fila/components/evasao/Modal'
import ModalFinalizarAtendimento from '@/components/pronto-atendimento/atendimento-triagem/components/finalizar-atendimento/Modal'

// Mixins.
import { error, repository } from '@/mixins'

// Enums
import preferenciaNome from '@/enums/cadastro/cidadao/preferenciaNome'

// Vuex.
import { mapActions } from 'vuex'

export default {
    components: {
        Form,
        ModalEvasao,
        ModalFinalizarAtendimento,
    },
    created() {
        this.setShowExitFormConfirmation()

        this.repositories = {
            atendimentoTriagem: this.getConectaSusRepository('prontoAtendimento.atendimentoTriagem'),
            fila: this.getConectaSusRepository('prontoAtendimento.fila')
        }

        this.load()
    },
    data: () => ({
        form: {},
        loaded: false,
        model: {},
        additionals: {},
        enums: { preferenciaNome }
    }),
    methods: {
        ...mapActions(['setLoading', 'unsetLoading', 'setShowExitFormConfirmation', 'unsetShowExitFormConfirmation']),
        load() {
            this.setLoading()

            this.repositories.atendimentoTriagem.create(this.$route.params.id)
                .then(response => {

                    this.additionals = response.data.additionals
                    this.form = response.data.form
                    this.model = response.data.model
                    this.model.filaId = this.$route.params.id
                    this.loaded = true
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        handleAlergiasScroll() {
            const element = document.querySelector('#alergias')
            element.scrollIntoView({ behavior: 'smooth', block: 'center' })
        },
        exit() {

            this.showExitConfirmation(async () => {

                this.setLoading()

                return this.repositories.fila.sendBack(this.$route.params.id)
                    .then(() => this.redirectToList())
                    .finally(() => this.unsetLoading())
            }, this.handleError)
        },
        redirectToList() {

            this.unsetShowExitFormConfirmation()

            this.$router.push({ name: 'pronto-atendimento-atendimento-triagem-index' }).catch(() => {})
        },
        handleDesfecho() {
            this.$refs.ModalFinalizarAtendimento.open()
        },
    },
    mixins: [error, repository],
}
</script>

<style scoped>
.sub-title {
    font-size: 13px;
    text-transform: uppercase;
    color: #222;
}
</style>